import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  NewBackButton,
  NoticeIcon,
  NoticeIconNew,
  PlusIcon,
} from "../../../../components/svgs";
import { Button, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import TopicCard from "../components/TopicCard";
import usePeerTalk from "../hooks/usePeerTalk";
import PledgeModal from "../components/PledgeModal";
import LoadingUI from "../components/LoadingUI";
import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";

const PeerTalkHome = () => {
  const { themeContext, theme } = useTheme();
  const { peerTalkData, comments, loading, error, userDetails } = usePeerTalk();
  const [isMyStories, setIsMyStories] = useState(false);
  const [isPledgeModalOpen, setIsPledgeModalOpen] = useState(false);

  const { stories = [] } = peerTalkData || {};

  useEffect(() => {
    analytics().then((anl) => logEvent(anl, "peerTalk_home_view", {}));
  }, []);

  const mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  const history = useHistory();

  const goToHome = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    history.push(`/home?token=${token}`);
  };

  const filteredData = isMyStories
    ? stories.filter((data) => data.author === userDetails.msisdn)
    : stories;

  const openPledgeModal = () => setIsPledgeModalOpen(true);
  const closePledgeModal = () => setIsPledgeModalOpen(false);

  const handleEdit = (data) => {
    history.push(`/peer_talk/edit_story/${data._id}`);
  };

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "fixed",
              zIndex: 100,
              background: "#fff",
            }}
          >
            <BackButtonContainer onClick={goToHome}>
              <NewBackButton />
            </BackButtonContainer>
            <StyledText>PeerTalk</StyledText>
            <NoticeIconNew
              fill="black"
              style={{ zIndex: 100, marginRight: 15 }}
              onClick={() => history.push("/peer_talk/peertalk_info")}
            />
          </div>

          {loading && <LoadingUI />}
          {error && <p>Error: {error}</p>}

          {/* Main content */}
          {!loading && !error && (
            <DescriptionBody color={mashupBackground}>
              <FilterButtons
                isMyStories={isMyStories}
                onToggle={() => setIsMyStories(!isMyStories)}
              />
              {filteredData.map((data) => (
                <TopicCard
                  key={data._id}
                  title={data.title}
                  backgroundImage={data.image}
                  category={data.category}
                  categoryButtonColor={data.color}
                  icon={data.icon}
                  numberOfComments={data.numberOfComments}
                  numberOfViews={data.numberOfViews}
                  isEditable={isMyStories}
                  datePosted={data.createdAt}
                  onClick={() =>
                    history.push("/peer_talk/topic_details", {
                      data,
                      comments: comments[data._id] || [],
                    })
                  }
                  onEdit={() => handleEdit(data)}
                />
              ))}
            </DescriptionBody>
          )}

          {/* Fixed button at the bottom */}
          <ButtonHolder>
            <Button
              onClick={openPledgeModal}
              style={{
                position: "fixed",
                bottom: "40px",
                marginInline: 20,
                height: "40px",
                width: "127px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                cursor: "pointer",
                gap: "5px",
                zIndex: 1000,
              }}
              color="#ffcc00"
            >
              <PlusIcon fill="none" color="black" />
              <StyledText color={"black"}>Add Story</StyledText>
            </Button>
          </ButtonHolder>
        </Children>
      </MainHolder>
      {isPledgeModalOpen && <PledgeModal onBackDropClick={closePledgeModal} />}
    </>
  );
};

const FilterButtons = ({ isMyStories, onToggle }) => (
  <FilterContainer>
    <Button
      onClick={onToggle}
      style={{
        height: "100%",
        width: "50%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        cursor: "pointer",
        borderRadius: "5px",
        backgroundColor: !isMyStories ? "#fff" : "#f7f5f5",
      }}
    >
      <StyledText color={!isMyStories ? "#333" : "#AEB3B8"}>
        All Stories
      </StyledText>
    </Button>
    <Button
      onClick={onToggle}
      style={{
        height: "100%",
        width: "50%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        cursor: "pointer",
        borderRadius: "5px",
        backgroundColor: isMyStories ? "#fff" : "#f7f5f5",
      }}
    >
      <StyledText color={isMyStories ? "#333" : "#AEB3B8"}>
        My Stories
      </StyledText>
    </Button>
  </FilterContainer>
);

const FilterContainer = styled.div`
  background: #f7f5f5;
  width: 350px;
  height: 43px;
  border-radius: 5px;
  margin-bottom: 12px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px;
`;

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  margin-top: 50px;
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default PeerTalkHome;
